var map = {
	"./beaker2/beaker2_active.png": 2108,
	"./beaker2/beaker2_disabled.png": 2109,
	"./beaker2/beaker2_success.png": 2110,
	"./bg-pattern.png": 873,
	"./body_substance1/body_substance1_active.png": 2111,
	"./body_substance1/body_substance1_disabled.png": 2112,
	"./body_substance1/body_substance1_success.png": 2113,
	"./cat-final-test-bg.png": 2114,
	"./cat-map-bg.png": 2115,
	"./catMapNextBtn/catMapNextBtn_active.png": 2116,
	"./clock.png": 2117,
	"./closeIcon.png": 267,
	"./completeIcon.png": 103,
	"./exam1/exam1.png": 2118,
	"./exam2/exam2.png": 2119,
	"./exam3/exam3.png": 2120,
	"./exam4/exam4.png": 2121,
	"./exam6/exam6.png": 2122,
	"./exam7/exam7.png": 2123,
	"./exam8/exam8.png": 2124,
	"./farm-map-bg (with last icon).png": 2125,
	"./farm-map-bg.png": 416,
	"./farm-map2-bg.png": 2126,
	"./farm4map/1.png": 874,
	"./farm4map/10.png": 875,
	"./farm4map/11.png": 876,
	"./farm4map/12.png": 877,
	"./farm4map/13.png": 878,
	"./farm4map/14.png": 879,
	"./farm4map/15.png": 880,
	"./farm4map/2.png": 881,
	"./farm4map/3.png": 882,
	"./farm4map/4.png": 883,
	"./farm4map/5.png": 884,
	"./farm4map/6.png": 885,
	"./farm4map/7.png": 886,
	"./farm4map/8.png": 887,
	"./farm4map/9.png": 888,
	"./farm5map/farm_5_video1.png": 889,
	"./farm5map/farm_5_video2.png": 890,
	"./farm5map/logic_wedge1.png": 891,
	"./farm5map/logic_wedge2.png": 892,
	"./farm5map/logic_wedge3.png": 893,
	"./farm5map/logic_wedge4.png": 894,
	"./farm5map/logic_wedge5.png": 895,
	"./farm5map/logic_wedge6.png": 896,
	"./farm5map/mechanisms_maker1.png": 897,
	"./farm5map/nail_and_screw1.png": 898,
	"./farm5map/сut_some_wood1.png": 899,
	"./farm_1_map/presentation.png": 900,
	"./farm_1_map/video.png": 901,
	"./farm_4_auth_bg.png": 902,
	"./farm_5_auth_bg.png": 903,
	"./farm_5_bg.png": 904,
	"./finalMapVideo1/finalMapVideo1_active.png": 2127,
	"./finalMapVideo1/finalMapVideo1_disabled.png": 2128,
	"./finalMapVideo1/finalMapVideo1_success.png": 2129,
	"./final_test1/final_test1_active.png": 2130,
	"./final_test1/final_test1_disabled.png": 2131,
	"./final_test1/final_test1_success.png": 2132,
	"./find_in_the_picture1/find_in_the_picture1_active.png": 2133,
	"./greece-blocks-mp-bg.png": 268,
	"./greeceBook.png": 269,
	"./hypothesis1/hypothesis1_active.png": 2134,
	"./hypothesis1/hypothesis1_disabled.png": 2135,
	"./hypothesis1/hypothesis1_success.png": 2136,
	"./hypothesis2/hypothesis2_active.png": 2137,
	"./hypothesis2/hypothesis2_disabled.png": 2138,
	"./hypothesis2/hypothesis2_success.png": 2139,
	"./initialMapVideo1/initialMapVideo1_active.png": 2140,
	"./initialMapVideo1/initialMapVideo1_disabled.png": 2141,
	"./initialMapVideo1/initialMapVideo1_success.png": 2142,
	"./lab_volume1/lab_volume1_active.png": 2143,
	"./lab_volume1/lab_volume1_disabled.png": 2144,
	"./lab_volume1/lab_volume1_success.png": 2145,
	"./laboratory10/laboratory10_active.png": 2146,
	"./laboratory10/laboratory10_disabled.png": 2147,
	"./laboratory10/laboratory10_success.png": 2148,
	"./measure1/measure1_active.png": 2149,
	"./measure1/measure1_disabled.png": 2150,
	"./measure1/measure1_success.png": 2151,
	"./measure2/measure2_active.png": 2152,
	"./measure2/measure2_disabled.png": 2153,
	"./measure2/measure2_success.png": 2154,
	"./measure3/measure3_active.png": 2155,
	"./measure3/measure3_disabled.png": 2156,
	"./measure3/measure3_success.png": 2157,
	"./measure4/measure4_active.png": 2158,
	"./measure4/measure4_disabled.png": 2159,
	"./measure4/measure4_success.png": 2160,
	"./measurement_duplicate1/measurement_duplicate1_active.png": 2161,
	"./measurement_duplicate1/measurement_duplicate1_disabled.png": 2162,
	"./measurement_duplicate1/measurement_duplicate1_success.png": 2163,
	"./notCompleteIcon.png": 905,
	"./phenomena1/phenomena1_active.png": 2164,
	"./phenomena1/phenomena1_disabled.png": 2165,
	"./phenomena1/phenomena1_success.png": 2166,
	"./phenomena2/phenomena2_active.png": 2167,
	"./phenomena2/phenomena2_disabled.png": 2168,
	"./phenomena2/phenomena2_success.png": 2169,
	"./phenomena3/phenomena3_active.png": 2170,
	"./phenomena3/phenomena3_disabled.png": 2171,
	"./phenomena3/phenomena3_success.png": 2172,
	"./school_task_auth_bg.png": 906,
	"./successArrow.png": 907,
	"./test1/test1_active.png": 2173,
	"./test1/test1_disabled.png": 2174,
	"./test1/test1_success.png": 2175,
	"./units1/units1_active.png": 2176,
	"./units1/units1_disabled.png": 2177,
	"./units1/units1_success.png": 2178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1038;